"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  learnAssign: {
    delAssgin: {
      delTip: '是否确认删除',
      onBoard: '是否在船',
      unlearnNum: '未学习数量',
      unlearnData: '未学习数据'
    },
    index: {
      filter: {
        processing: '进行中',
        completed: '已完成'
      },
      expired: '是否过期',
      tip: '注意多个账号用逗号隔开',
      userAccount: '用户账号',
      shoreExam: '岸端是否考试',
      shipExam: '船端是否考试',
      initFrom: '发起位置',
      initShore: '岸基发起',
      initShip: '船端发起',
      taskType: '任务类型',
      executedShip: '执行船舶',
      completionStatus: '完成状态',
      all: '全部',
      assignDept: '我的部门指派',
      myAssign: '我的指派',
      learnTask: '学习任务',
      workTask: '工作任务',
      assignType: '指派类型',
      feedbackFlag: '岸端完成后反馈结果',
      vesselFeedbackFlag: '船端完成后反馈结果',
      uploadAttach: '岸端是否要求上传附件',
      vesselUploadAttach: '船端是否要求上传附件',
      taskRequirements: '任务要求',
      taskAssignment: '任务分派',
      company: '公司',
      shorePostId: '岸端岗位',
      sysPostId: '船端岗位',
      otherTasks: '其他任务',
      applicableCompany: '适用公司',
      roleMonitor: '监控岗位',
      monitoring: '任务指派与监控',
      questionsNumber: '试题数量',
      correct: '正确',
      incorrect: '错误',
      retest: '重考',
      submitExam: '提交考试',
      exam: '学习完考试',
      startExam: '进入考试',
      confirmSubmit: '是否提交考试',
      confirmRetest: '是否重新考试',
      addAssign: '新增指派',
      title: '体系学习',
      item: '学习指派',
      cancelMonitor: '取消监控',
      query: {
        itemName: '项目名称'
      },
      systemDocuments: '体系文件',
      companyNotice: '公司通告',
      rulesCirculars: '通告与法规',
      externalRegulations: '外部法规',
      otherControlledDoc: '支持性文件',
      bestImplementation: '最佳实践',
      hasBeenLearning: '已学习',
      didNotLearn: '未学习',
      operationSuccessful: '操作成功',
      selectOne: '请选择一条记录',
      cancelLearnMission: '是否取消选中人员的学习任务？',
      qualityFileType: '文件类型',
      qualityFileDate: '生效日期',
      today: '今天',
      week: '一周',
      mounth: '一月内',
      year: '一年内',
      operationFailure: '操作失败',
      table: {
        qualityFileNo: '文件编号',
        qualityFileName: '文件名称',
        qualityFileType: '类型',
        assignDate: '指派日期',
        learnDeadline: '要求完成日期',
        sysPersonId: '岸端学习人员',
        sysPostId: '船端学习岗位',
        vesselCode: '学习船舶',
        learnDetail: '学习反馈情况',
        learnStatus: '学习状态',
        feedBackDetail: '反馈情况',
        personOrPost: '学习人员/岗位'
      },
      form: {
        yes: '是',
        no: '否',
        qualityFileType: '类型',
        qualityFileName: '学习文件',
        learnDeadline: '要求完成日期',
        feedbackFlag: '学习完成后反馈结果',
        sysPostId: '岸端学习岗位',
        sysShipId: '船端学习岗位',
        vesselCode: '学习船舶',
        learnRemark: '学习要求',
        assignTaskName: '任务名称',
        assignName: '指派人',
        monitor: '监控人',
        vessel: '部门/船舶',
        position: '岗位',
        userName: '姓名',
        learnDeatil: '学习状态',
        learnedDate: '学习日期',
        actual: '要求反馈',
        feedbackContext: '反馈内容',
        reservedInt1: '待办变动情况',
        reservedDate: '变动日期',
        reservedStr1: '变动原因',
        attachment: '附件',
        feedbackShip: '反馈船舶',
        ship: '船舶',
        dept: '部门',
        learnFlag: '学习状态'
      }
    },
    btn: {
      deleteUnlearnedData: '删除未学习数据'
    },
    msg: {
      operationSuc: '操作成功',
      operationFail: '操作失败',
      checkTask: '请添加任务执行人员后再提交'
    }
  }
};